var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-187f929b": "",
    "data-v-c9b21153": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    className: "icon small",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4825 7.29257L13.3043 6.39478L10.5413 0.79638C10.4306 0.572235 10.2153 0.459961 10 0.459961L10.0008 16.5646L15.526 19.4697C15.9691 19.7023 16.4862 19.3264 16.4017 18.8334L15.3465 12.6797L19.817 8.32195C20.1755 7.97265 19.9775 7.3646 19.4825 7.29257Z",
    fill: "#429E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0491 12.2584C14.0491 12.2584 15.0021 17.8129 15.0053 17.8314C15.0021 17.831 10.0777 16.5839 10.0008 16.5646C10 16.5642 4.47407 19.4697 4.47407 19.4697C4.03101 19.7023 3.5139 19.3264 3.59841 18.8334L4.65354 12.6797L0.183111 8.32195C-0.175441 7.97265 0.0225473 7.3646 0.517518 7.29257L6.6958 6.39478L9.45878 0.79638C9.56945 0.572235 9.78474 0.459961 10 0.459961L12.5027 7.4982L18.0986 8.31149L14.0491 12.2584Z",
    fill: "#64AB88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarV2);
export default __webpack_public_path__ + "static/media/star_v2.7a7386104d054e1788cf01c4a07b5150.svg";
export { ForwardRef as ReactComponent };